<template>
    <HpoPatientModalSection :title="pgettext('label', 'Adult / child')">
        <template v-slot:body>
            <div class="phc-buttons-row priority-buttons">
                <SelectButton :value="false"
                              v-model="isChild">
                    {{ pgettext('label', 'adult') }}
                </SelectButton>
                <SelectButton :value="true"
                              v-model="isChild">
                    {{ pgettext('label', 'child') }}
                </SelectButton>
            </div>
        </template>
    </HpoPatientModalSection>
</template>

<script setup>
import HpoPatientModalSection from "../../HpoPatientModalSection.vue";
import SelectButton from "../../SelectButton.vue"
import {computed} from "vue"


const props = defineProps({
    modelValue: {
        type: Boolean,
        required: false,
        default: null,
    }
})

const emit = defineEmits('update:modelValue')

const isChild = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value)
});
</script>

